import { Link } from "react-router-dom";
import signalLogoDark from "@/assets/signal-logo-on-dark.svg";
import signalLogoLight from "@/assets/signal-logo-on-light.svg";

// The "signal" brand lockup (mark + wordmark), shared between the header, the
// splash, and the auth card so the branding lives in one place (DRY). `size`
// picks the header (sm) vs the larger hero (lg). `onLight` flips the artwork +
// label colors for a light surface (the white auth card): the official
// Primary-Black lockup (indigo mark / Ink wordmark) with a dim label; the
// default is Primary-White (indigo mark / white wordmark) for the dark chrome +
// hero. Getting that pair backwards leaves the wordmark invisible, so
// Brand.test.tsx pins it. The link's aria-label carries the full accessible
// name (the image is decorative, alt="").
export function Brand({
  size = "sm",
  onLight = false,
}: {
  size?: "sm" | "lg";
  onLight?: boolean;
}) {
  const logoClass = size === "lg" ? "h-10" : "h-[1.8rem]";
  const labelClass = onLight
    ? "text-xs font-medium uppercase tracking-wide text-brk-dim sm:text-sm"
    : "text-xs font-semibold uppercase tracking-wide text-brk-accent sm:text-sm";
  const dividerClass = onLight ? "border-brk-border" : "border-white/20";

  return (
    <Link
      to="/"
      className={`inline-flex items-center gap-2.5 no-underline ${onLight ? "text-brk-text" : "text-white"}`}
      aria-label="Signal Specialty Broker Portal — home"
    >
      <img
        src={onLight ? signalLogoLight : signalLogoDark}
        alt=""
        className={`${logoClass} w-auto`}
      />
      <span className={`border-l pl-2.5 ${dividerClass} ${labelClass}`}>
        Broker Portal
      </span>
    </Link>
  );
}
